// extracted by mini-css-extract-plugin
export default {"mainContent":"App_mainContent__ekb0D"};